<template>
    <div :class="[colClasses, { 'flex': colClasses}]">
        <fullscreen ref="fullscreen">
            <div class="app-card" :class="[customClasses, { 'd-none': close }]">
                <app-card-heading :heading="heading" :closeable="closeable" :reloadable="reloadable" :fullScreen="fullScreen" :exportexcel="exportexcel" :withTabs="withTabs" :tabs="tabs" @onChangeTabCallback="onChangeTab" @onCollapse="onCollapse" @onReload="onReload" @onClose="onClose" @onExportPdf="onExportPdf" @onExportPpt="onExportPpt" @onExportExcel="onExportExcel">
                </app-card-heading>
                <app-card-content :extraClass="[contentCustomClass]" :fullBlock="fullBlock">
                    <slot></slot>
                </app-card-content>
                <app-card-footer v-if="footer">
                    <slot name="footer"></slot>
                </app-card-footer>
                    <app-card-menu :closeable="closeable" :reloadable="reloadable" :fullScreen="fullScreen" :exportexcel="exportexcel" :withTabs="withTabs" :tabs="tabs" @onChangeTabCallback="onChangeTab" @onCollapse="onCollapse" @onReload="onReload" @onClose="onClose" @onExportPdf="onExportPdf" @onExportPpt="onExportPpt" @onExportExcel="onExportExcel">
                    </app-card-menu>
                <app-section-loader :status="reload"></app-section-loader>
            </div>
        </fullscreen>
    </div>
</template>
<script>
import AppCardMenu from "./AppCardMenu";
import AppCardHeading from "./AppCardHeading";
import AppCardFooter from "./AppCardFooter";
import AppCardContent from "./AppCardContent";
import AppSectionLoader from "../AppSectionLoader/AppSectionLoader";
import { calculatePercentBetweenYear } from "Helpers/helpers";

import $ from "jquery";
import jsPDF from 'jspdf';
import PptxGenJS from 'pptxgenjs';
import XLSX from 'xlsx'
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

export default {
    props: [
        "heading",
        "colClasses",
        "customClasses",
        "fullBlock",
        "contentCustomClass",
        "closeable",
        "reloadable",
        "fullScreen",
        "footer",
        "withTabs",
        "tabs",
        "onChangeTabCallback",
        "mainFilters",
        "apiUrl",
        "exportexcel",
    ],
    data() {
        return {
            reload: false,
            close: false
        };
    },
    components: {
        AppCardHeading,
        AppCardFooter,
        AppCardContent,
        AppSectionLoader,
        AppCardMenu
    },
    methods: {
        onCollapse() {
            this.$refs["fullscreen"].toggle();
        },
        onReload() {
            this.reload = true;
            let self = this;
            setTimeout(() => {
                self.reload = false;
            }, 1500);
        },
        onClose() {
            this.close = true;
        },
        onChangeTab(value) {
            this.$emit("onChangeTabCallback", value);
        },
        async onExportPdf() {
            this.reload = true;
            var filename = $(this.$el).find(".app-card-title h3").text() + ".pdf";
            this.output = await this.$html2canvas(this.$el, { type: 'dataURL' });
            this.dimensions = await this.getImageDimensions(this.output);
            let pdf = new jsPDF("p", "mm", "a4");
            var position = 0;
            var width = pdf.internal.pageSize.getWidth();
            var height = pdf.internal.pageSize.getHeight();
            // (original height / original width) x new width = new height
            var _ratio = (this.dimensions.h / this.dimensions.w);
            var _new_w = width - 6;
            var _new_h = _new_w * _ratio;
            var heightLeft = _new_h;
            //3, 13
            pdf.addImage(this.output, 'PNG', 0, position, _new_w, _new_h);
            heightLeft -= parseInt(height);
            
            // loop for add data on new page break
            while (heightLeft >= 0) {
                position = heightLeft - _new_h;
                pdf.addPage();
                pdf.addImage(this.output, 'PNG', 0, position, _new_w, _new_h);
                heightLeft -= height;
            }
            this.reload = false;
            pdf.save(filename);
        },
        async onExportPpt() {
            this.reload = true;
            var filename = $(this.$el).find(".app-card-title h3").text() + ".pptx";
            this.output = await this.$html2canvas(this.$el, { type: 'dataURL' });
            this.dimensions = await this.getImageDimensions(this.output);
            var pptx = new PptxGenJS();
            // (original height / original width) x new width = new height
            // Default Slide Layout 10 x 5.625 inches and 1 inch = 96 px
            var width = 10 * 96;
            var height = 5.625 * 96;
            var _ratio = (this.dimensions.h / this.dimensions.w);
            var _new_w = width - 6;
            var _new_h = _new_w * _ratio;
            var _new_w_inch = _new_w / 96;
            var _new_h_inch = _new_h / 96;
            // console.log(this.dimensions, width, height, _new_w, _new_h, _new_w_inch, _new_h_inch);
            const option = {
                data: this.output,
                x: 0,
                y: 0,
                w: _new_w_inch,
                h: _new_h_inch,
                sizing: { type: 'contain', x: 0, y: 0, w: 10, h: 5.625 }
            }
            var slide = pptx.addNewSlide();
            slide.addImage(option);
            this.reload = false;
            pptx.save(filename);
        },
        async onExportExcel() {
            this.reload = true;
            var filename = $(this.$el).find(".app-card-title h3").text() + ".xlsx";
            await this.getRawData();
            var dataWS = XLSX.utils.json_to_sheet(this.rawData)
            var wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS, 'data')
            this.reload = false;
            XLSX.writeFile(wb, filename)
        },
        async getImageDimensions(file) {
            return new Promise(function(resolved, rejected) {
                var i = new Image()
                i.onload = function() { resolved({ w: i.width, h: i.height }) };
                i.src = file
            })
        },
        async getRawData() {
            var _params = {};
            // calulate _params from main_filters
            var main_filters = this.mainFilters;
            if (typeof main_filters !=='undefined' && main_filters !== null) {
                if (main_filters.start !== null && main_filters.end !== null) {
                    _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                    _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
                }
                if (main_filters.location_source !== null) {
                    _params.location_source = main_filters.location_source;
                }
                if (main_filters.location_destination != null) {
                    _params.location_destination = main_filters.location_destination;
                }
                if (main_filters.year != null) {
                    _params.year = main_filters.year;
                }
            }            
            const request = {
                params: qs.parse(_params)
            };
            const response = await instance.get(this.apiUrl, request);
            if (typeof response.data.rows !=='undefined') {
                this.rawData = response.data.rows;
            } else {
                let rawData = typeof response.data ==='object' ? [response.data] : response.data;
                let newArr = [];

                rawData.forEach((rows) => {
                    let setDatas = [];
                    for (let i in rows) {
                    if (! Array.isArray(rows[i]) && typeof rows[i].currentYear !=='undefined' && typeof rows[i].currentYear.year !=='undefined') {
                        setDatas = [{
                            'year': rows[i].currentYear.year,
                            'Country': rows[i].location_source,
                            'Number': rows[i].currentYear.totalImmigrants,
                            'Percent': calculatePercentBetweenYear(parseFloat(rows[i].currentYear.totalImmigrants), parseFloat(rows[i].previousYear.totalImmigrants))+'%'
                        }]
                    } else if (Array.isArray(rows[i])) {
                        setDatas = rows[i].map((item) => {                        
                                if (typeof item.totalImmigrants !=='undefined') {
                                    item.totalImmigrants = numeral(item.totalImmigrants).format('0,00')
                                }
                                return item
                            })
                    }
                    
                        newArr.push(...setDatas);
                    }
                });
                
                this.rawData = newArr;
            }
            
        }
    }
};
</script>